import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Funnel from "@/pages/Funnel";
import Dashboard from "@/pages/Dashboard";
import ReviewsWall from "@/pages/ReviewsWall";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Funnel />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reviews" element={<ReviewsWall />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
